export const getLoginUrl = (isExport: boolean) =>
  isExport ? "/export/login" : "/login";
